import { render, staticRenderFns } from "./WarpRealityButton.vue?vue&type=template&id=9a4b8a7c&scoped=true&"
import script from "./WarpRealityButton.vue?vue&type=script&lang=js&"
export * from "./WarpRealityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4b8a7c",
  null
  
)

export default component.exports